import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getBasicBuyerInformation } from '../../services/buyer'

export const GET_BASIC_BUYER_INFORMATION = 'GET_BASIC_BUYER_INFORMATION'
export const GET_BASIC_BUYER_INFORMATION_ERROR = 'GET_BASIC_BUYER_INFORMATION_ERROR'
export const GET_BASIC_BUYER_INFORMATION_SUCCESS = 'GET_BASIC_BUYER_INFORMATION_SUCCESS'
export const onGetBasicBuyerInformation = makeActionCreator(GET_BASIC_BUYER_INFORMATION)
export const onGetBasicBuyerInformationError = makeActionCreator(GET_BASIC_BUYER_INFORMATION_ERROR, 'payload')
export const onGetBasicBuyerInformationSuccess = makeActionCreator(GET_BASIC_BUYER_INFORMATION_SUCCESS, 'payload')
export const onGetBasicBuyerInformationThunk = payload => async dispatch => {
  dispatch(onGetBasicBuyerInformation())

  try {
    const { data } = await getBasicBuyerInformation({ actionType: GET_BASIC_BUYER_INFORMATION, dni: payload })
    const buyer = data?.payload?.respuesta

    const email = buyer?.correo === '' ? 'Sin información' : buyer?.correo ?? 'Sin información'
    const legalAddress = `${buyer?.direccion?.domicilioLegal}, ${buyer?.direccion?.comuna}, ${buyer?.direccion?.region}`
    const phone = buyer?.telefono === '' ? 'Sin información' : buyer?.telefono ?? 'Sin información'
    const sector = buyer?.sector === '' ? 'Sin información' : buyer?.sector ?? 'Sin información'
    const webSite = buyer?.sitioWeb === '' ? 'Sin información' : buyer?.sitioWeb ?? 'Sin información'

    return dispatch(
      onGetBasicBuyerInformationSuccess({
        entCode: buyer?.codigoEntidad,
        dni: buyer?.rut,
        orgLegalName: buyer?.razonSocial || buyer?.nombreFantasia,
        orgName: buyer?.nombreFantasia,
        webSite,
        email,
        phone,
        sector,
        address: legalAddress ?? 'Sin información'
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 404:
        reason = 'DNI_DOES_NOT_MATCH_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetBasicBuyerInformationError({
        dni: payload.dni,
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
